module.exports = __webpack_public_path__ + "static/media/ubuntu.947feac9.svg";